import dayjs from "dayjs";

export const fetchDetailsForUsersIndividually = async (accountIds) => {
  try {
    const promises = accountIds.map(async (accountId) => {
      const res = await window.AP.request(
        `/rest/api/user?accountId=${accountId}`
      );
      const resData = JSON.parse(res.body);
      return resData;
    });

    const response = await Promise.all(promises);
    return response;
  } catch (error) {
    return [];
  }
};

export const getUsersDetails = async ({ records, databaseFieldId }) => {
  try {
    const accountIds = records.map((user) => user.accountId);
    const usersWithDetails = await fetchDetailsForUsersIndividually(accountIds);
    const formattedUsers = usersWithDetails.map((user) => {
      const userValues = records.find(
        (r) => r.accountId === user.accountId
      )?.values;

      const dateField = userValues[`${databaseFieldId}`];
      const formattedDateField = dayjs.unix(dateField).format("MMM D");

      const dateFieldUnix = dayjs.unix(dateField);
      const dateFieldUnixCurrentYear = dayjs
        .unix(dateField)
        .set("year", dayjs().get("year"));

      const daysLeftFromCurrentYear = dateFieldUnixCurrentYear
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .diff(dayjs().hour(0).minute(0).second(0).millisecond(0), "day");

      const yearsLeftFromCurrentYear = Math.abs(
        dateFieldUnix.diff(dateFieldUnixCurrentYear, "year")
      );

      return {
        accountId: user.accountId,
        name: user.displayName,
        avatarUrl: `${window.AP._hostOrigin}${user.profilePicture.path}`,
        formattedDateField,
        daysLeft: daysLeftFromCurrentYear,
        yearsLeft: yearsLeftFromCurrentYear,
        hasBirthday: !!dateField,
      };
    });
    return formattedUsers;
  } catch (error) {
    console.log("error", error);
    console.log("Can not fetch data for users individually.");
    return [];
  }
};
